import { getParamFromUrl } from '@/common/utils';
/**
 * @description 获取当前语言码，并映射到相应语言包
 * @see ISO 639-1 代码表 https://zh.wikipedia.org/wiki/ISO_639-1%E4%BB%A3%E7%A0%81%E8%A1%A8
 */
const langMap = {
  cn: 'cn,zh,zh-hans,zh-cn,zh-hans-cn,zh-sg,zh-hans-sg', // 简体中文
  tw: 'tw,zh-hant,zh-hk,zh-mo,zh-tw,zh-hant-hk,zh-hant-mo,zh-hant-tw', // 繁体中文
  en: 'en', // 英语
  th: 'th', //  傣语
  vi: 'vn,vi', //  越南语
  ru: 'ru', // 俄语
  id: 'id', // 印尼语
  ko: 'ko', // 朝鲜语
  hi: 'in,hi', // 印地语
  ar: 'ar', // 阿拉伯语
  af: 'af', // 南非语
  tr: 'tr', // 土耳其语
  es: 'es', // 西班牙语
  ms: 'ms', // 马来语
  pt: 'pt', // 葡萄牙语
  ja: 'ja,jp', // 日语
  ur: 'ur', // 乌尔都语
  de: 'de', // 德语
  ne: 'ne', // 尼泊尔语
  bn: 'bn', // 孟加拉语
  gu: 'gu', // 古吉拉特语
  kn: 'kn', // 埃纳德语
  mr: 'mr', // 马拉地语
  pa: 'pa', // 旁遮普语
  ta: 'ta', // 泰米尔语
  te: 'te', // 泰卢固语
  fil: 'fil,tl', // 菲律宾语
  it: 'it', // 意大利语
  uk: 'uk', // 乌克兰语
  be: 'be', // 白俄罗斯语
  kk: 'kk', // 哈萨克语
  fa: 'fa', // 波斯语
  da: 'da', // 丹麦语
  ml: 'ml', // 马拉雅拉姆语
  or: 'or', // 奥里雅语
  as: 'as', // 阿萨姆语
  ka: 'ka', // 格鲁吉亚语
  sa: 'sa', // 梵语
  uz: 'uz', // 乌兹别克语
  hne: 'hne', // 恰蒂斯加尔语
  jv: 'jv', // 爪哇语
  raj: 'raj', // 拉贾斯坦语
  km: 'km,kh,khm', // 高棉语
  fr: 'fr,fra,fre', // 法语
  si: 'si,sin', // 僧伽罗语
  pl: 'pl,pol,pl-pl', // 波兰语
  ro: 'ro', // 罗马尼亚语
  mm: 'my,mm', // 缅甸语
  // se为 乌拉尔语系 北萨米语，sv才是瑞典，这里暂时不改动
  se: 'se,sv,smj-se,sma-se', // 瑞典
  // fy-nl应为 印欧语系 弗里斯兰语，这里暂时不改动
  nl: 'nl,fy-nl', // 荷兰
};

/**
 * @description ISO 3166-1 国家码映射（facebook标准）
 * @see https://zh.wikipedia.org/wiki/ISO_3166-1?fbclid=IwAR1l_8YPkeiFg8S5-n1_iiBq0K4gIBJyBBKGOcCfn16qF5I_hdzDRXEH2nU
 */
// const codeToCountryISO3166 = {
//   cn: 'CN',
//   tw: 'TW',
//   en: 'US',
//   th: 'TH',
//   vi: 'VN',
//   es: 'BR',
//   ru: 'RU',
//   id: 'ID',
//   ko: 'KR',
//   hi: 'IN',
//   ar: 'EG', //  阿拉伯语不能定位到具体国家，暂定人数最多的埃及
//   af: 'ZA',
//   tr: 'TR',
//   ms: 'MY',
//   pt: 'BR',
//   ja: 'JP',
//   de: 'DE',
//   ne: 'NP',
//   bn: 'BD',
// };

/**
 * @description ISO 639-1 语言码映射（facebook标准）
 * @see https://zh.wikipedia.org/wiki/ISO_639-1%E4%BB%A3%E7%A0%81%E8%A1%A8
 */
// const codeToLocaleISO639 = {
//   cn: 'zh',
//   tw: 'zh',
// };

/**
 * 获取当前语言码，并映射到相应语言包
 */
export const getCurrentLocale = (curLang) => {
  let userLanguage = getParamFromUrl('lang') || curLang;
  let currentLocale = '';

  if (userLanguage) {
    userLanguage = userLanguage.toLowerCase();
    currentLocale = Object.keys(langMap).find(
      (key) => langMap[key].split(',').indexOf(userLanguage) > -1,
    );

    if (!currentLocale) {
      // 增加一个兜底行为，ja-ZH找不到，则取前“-”前面的字符匹配langMap的values
      // ep：my-aaa 则匹配 ms,my中的my，lang结果为ms
      const newUserLanguage = userLanguage.split('-')[0];
      currentLocale = Object.keys(langMap).find((key) => {
        const values = langMap[key].split(',');
        return values.indexOf(newUserLanguage) > -1;
      });
    }
  }

  if (!currentLocale) {
    console.log(`Cannot find language in lang map, set default locale en`);
  }

  return currentLocale || 'en';
};
